// @ts-check
import _ from 'lodash';
import Icon from 'components/base/Icon';
import { Flex, Padding, Separator } from 'components/base/layout-components';
import { TRACKING } from 'common/constants/constants';
import * as LighthouseService from 'common/services/lighthouse.service';
import { createNotificationCutomizationModalOptions } from 'modals/modal-options-factory';
import * as TrackingService from 'common/services/tracking.service';
import { LBButton } from '@linearb/buzz';

const ActionsCol = ({
  toggleModal,
  toggleSnackBar,
  selectedTeamId,
  id,
  name,
  articleId = '16zfs7qnli',
  notifications,
  setNotifications,
  onSaveSetting,
  withEstimation,
  inModalDescription,
  NOTIFICATION_CONFIG,
  NOTIFICATIONS_BUILDER,
  prMerged,
  predictionCount,
  setPredictionCount
}) => {
  const isEditable = _.get(NOTIFICATION_CONFIG, 'thresholds', null);
  return (
    <Flex items='center' justify='end' width='20rem'>
      <Padding r='small'>
        {isEditable && (
          <LBButton
            size='sm'
            variant='ghost'
            onClick={() => {
              TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
                page: TRACKING.PAGES.SETTINGS,
                page_tab: TRACKING.PAGE_TABS.NOTIFICATIONS,
                click_type: TRACKING.CLICK.EDIT_NOTIFICATION,
                name
              });

              toggleModal(
                createNotificationCutomizationModalOptions({
                  selectedTeamId,
                  toggleSnackBar,
                  id,
                  name,
                  notifications,
                  setNotifications,
                  onSubmit: () => {},
                  onCancel: () => toggleModal(),
                  onClose: () => toggleModal(),
                  onSaveSetting,
                  withEstimation,
                  inModalDescription,
                  NOTIFICATION_CONFIG,
                  NOTIFICATIONS_BUILDER,
                  prMerged,
                  predictionCount,
                  setPredictionCount
                })
              );
            }}
          >
            Edit
          </LBButton>
        )}
      </Padding>
      <Separator />
      <Padding l='small'>
        <LBButton
          size='icon'
          variant='ghost'
          onClick={() => {
            TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
              page: TRACKING.PAGES.SETTINGS,
              page_tab: TRACKING.PAGE_TABS.NOTIFICATIONS,
              click_type: TRACKING.CLICK.LEARN_MORE,
              name
            });

            LighthouseService.navigateArticle(articleId);
          }}
        >
          <Icon name='helpicon' size='smaller' />
        </LBButton>
      </Padding>
    </Flex>
  );
};

export default ActionsCol;
